import { removedUnspecifiedTagIds, tagAxisIds, tagAxesMap, getAllParentsDetailedTag } from '@cpsy-rmap-project/tags'
import { Paper, DetailedPaper } from '@cpsy-rmap-project/web-core/repositories'
import _ from 'lodash'

const getAllTagIdsFromPaper = ({
  paper,
  enableIncludeParents,
  isPickupFirstSelectedTag
}: {
  paper: Paper
  enableIncludeParents?: boolean
  isPickupFirstSelectedTag?: boolean
}) =>
  _.flatten(
    tagAxisIds.map(tagAxisId => {
      // eslint-disable-next-line no-nested-ternary
      const tagIds = isPickupFirstSelectedTag ? (paper[tagAxisId][0] ? [paper[tagAxisId][0]] : []) : paper[tagAxisId]
      if (enableIncludeParents) {
        const tagIdsIncludeParents = _.flatten(
          tagIds.map(tagId => {
            const tag = tagAxesMap[tagAxisId][tagId]
            return tag ? getAllParentsDetailedTag(tag) : []
          })
        )
        return tagIdsIncludeParents
      }
      return tagIds
    })
  )

const hasMatchTags = ({ paper, tagIds }: { paper: Paper; tagIds: string[] }) => {
  const paperAllTagIds = getAllTagIdsFromPaper({
    paper,
    enableIncludeParents: true,
    isPickupFirstSelectedTag: false // NOTE: trueは絞り込みが強すぎるのでfalseにしてタグ付けされたタグ全てを対象にする
  })
  return tagIds.map(tagId => paperAllTagIds.includes(tagId)).every(v => v)
}

/** @deprecated 計算遅い */
export const specializePapersByAllTagIds = ({ papers, tagIds }: { papers: DetailedPaper[]; tagIds: string[] }) =>
  papers.filter(paper => hasMatchTags({ paper, tagIds }))

// NOTE: Firestoreから取得する時点でソートされているため不要
// return _.orderBy(
//   papers.filter(paper => hasMatchTags({ paper, tagIds })),
//   'citedCount',
//   'desc'
// )

const getShortenAuthorName = (name: string) => {
  // eslint-disable-next-line no-irregular-whitespace
  const nameArray = name.split(/[\s,.\-　]/)
  const compactNameArray = _.compact(nameArray)
  if (compactNameArray.length === 0) {
    return '' // 想定外
  }
  return compactNameArray
    .map((n, index) => {
      if (index === compactNameArray.length - 1) {
        return ` ${_.startCase(_.lowerCase(n))}`
      }
      return `${_.upperCase(n).charAt(0)}.`
    })
    .join('')
}

export const getFirstAuthor = (authors: string) => {
  const authorArray = authors.split(',')
  return authorArray.length > 0 ? getShortenAuthorName(authorArray[0]) : '' // NOTE: [0]がないのは想定外ではある
}

export const removedUnspecifiedTag = (paper: Paper) => ({
  ...paper,
  rdocConstructs: removedUnspecifiedTagIds('rdocConstructs', paper.rdocConstructs),
  unitOfAnalysis: removedUnspecifiedTagIds('unitOfAnalysis', paper.unitOfAnalysis),
  dsm5: removedUnspecifiedTagIds('dsm5', paper.dsm5),
  compMathMethodExperimentalDesign: removedUnspecifiedTagIds(
    'compMathMethodExperimentalDesign',
    paper.compMathMethodExperimentalDesign
  ),
  compMathMethodDataType: removedUnspecifiedTagIds('compMathMethodDataType', paper.compMathMethodDataType),
  compMathMethodModels: removedUnspecifiedTagIds('compMathMethodModels', paper.compMathMethodModels),
  symptomatology: removedUnspecifiedTagIds('symptomatology', paper.symptomatology)
})
